"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const nav_1 = require("components/cosmos/nav");
const badge_1 = require("components/v2/badge");
const constants_1 = require("configs/routes/constants");
const constants_2 = require("modules/app/services/ga/constants");
const GtagService_1 = __importDefault(require("modules/app/services/ga/GtagService"));
const tracksPopover_1 = __importDefault(require("../tracksPopover/tracksPopover"));
const tabs_module_scss_1 = __importDefault(require("./tabs.module.scss"));
const Tab = ({ activeIndex, items, className, isMobile, onClick }) => {
    const handleClick = (index) => {
        const track = items[index].track;
        if (track) {
            GtagService_1.default.sendPageEvent({
                subsection: constants_1.PAGE_VIEW_EVENTS.CONTENT.MAIN,
                subsection2: track,
                sourceType: constants_2.SOURCE_TYPES.ONLINE_COURSE
            });
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(index);
    };
    return ((0, jsx_runtime_1.jsx)(nav_1.Nav, { type: "pills", className: (0, classnames_1.default)('_gap-4 _p-0', className), children: items.map((tab, index) => {
            const isActive = index === activeIndex;
            const allowedShowTracksPopover = tab.track === 'Track' && !isMobile;
            return ((0, jsx_runtime_1.jsxs)(nav_1.Nav.Item, { active: isActive, className: (0, classnames_1.default)('_position-relative _d-flex _align-items-center _m-0 _font-weight _p-0', {
                    '_bg-gray-900 _border-gray-900 _text-white': isActive,
                    '_bg-white _text-gray-900': !isActive
                }, tabs_module_scss_1.default.navItem), children: [allowedShowTracksPopover && ((0, jsx_runtime_1.jsx)("div", { className: tabs_module_scss_1.default.containerTracksPopover, children: (0, jsx_runtime_1.jsx)(tracksPopover_1.default, { onClick: () => handleClick(index) }) })), (0, jsx_runtime_1.jsxs)("button", { className: "bg-transparent _border-0 _py-2 _px-4", onClick: () => handleClick(index), children: [tab.name, tab.badge && (0, jsx_runtime_1.jsx)(badge_1.Badge, { children: tab.badge })] })] }, tab.name));
        }) }));
};
exports.default = Tab;
